import React from 'react';
import {ErrorMessage, Field} from 'formik';
type Props = {
	label: string;
	fieldName: string;
	placeholder: string;
	value: string;
	touched?: boolean;
	error?: boolean;
};
const TextFilterField: React.FC<Props> = ({
	label,
	fieldName,
	placeholder,
	value,
	touched,
	error,
}) => {
	return (
		<>
			<div className="form-filter__item form-filter__item-id1">
				<label htmlFor="showCountry" className="id1__label1">
					{label}
				</label>
				<div>
					<Field
						value={value}
						placeholder={placeholder}
						type="text"
						name={fieldName}
						className="id1__input1"
					/>
					{touched && error && (
						<div
							style={{
								paddingTop: '2px',
								color: 'red',
							}}
						>
							<ErrorMessage name={fieldName} component="span" />
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default TextFilterField;
